import React from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Button } from 'baby-design'
import { ReturnItemActionProps } from './ReturnItemAction.types'

const ReturnItemAction: React.FC<ReturnItemActionProps> = ({ reservation }) => (
  <Button
    data-testid="GiftDetails__GiftActions__ReturnItem"
    href={reservation.returnWebUrl as string}
    size="md"
    target="_blank"
    variant="tertiary"
  >
    Return item
  </Button>
)

export default ReturnItemAction
